import type { UniqueInfo } from '~/schema/types/generated'

export function getArrayOfKeyValueObjects({
    objectToConvert,
    additionalElements = [],
    removeDuplicates = true,
}: {
    objectToConvert: Record<string, any>
    additionalElements?: UniqueInfo[]
    removeDuplicates?: boolean
}): UniqueInfo[] {
    // Convert the object keys/values into an array of key-value pairs
    const convertedArray: UniqueInfo[] = Object.entries(objectToConvert).map(([key, value]) => ({ key, value }))

    // Combine with additional elements
    const combinedArray = [...convertedArray, ...additionalElements]

    // Remove duplicates if the option is enabled
    if (removeDuplicates) {
        const seenKeys = new Set<string>()
        return combinedArray.filter(({ key }) => {
            if (!key || seenKeys.has(key)) {
                return false
            }

            seenKeys.add(key)

            return true
        })
    }

    return combinedArray
}
